module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flex items-center justify-center font-manrope",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "relative w-full max-w-2xl"
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center relative"
  }, [_c('div', {
    staticClass: "h-12 w-12 rounded-full bg-white border border-gray-200 flex items-center justify-center"
  }, [_vm._v("\n        🌟\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center justify-center px-2 pt-6 pb-6 text-center"
  }, [_c('h2', {
    staticClass: "font-poppins text-xl font-semibold text-slate-900"
  }, [_vm._v("\n          It's almost showtime\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-sm leading-6 text-slate-600"
  }, [_vm._v("\n          Get everything ready in a few steps and kick off the discussion.\n        ")]), _vm._v(" "), _c('ol', {
    staticClass: "flex items-center text-left mt-5 space-x-4"
  }, [_c('li', {
    staticClass: "flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-check text-lg text-green-600"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('div', {
    staticClass: "text-sm font-semibold text-slate-800"
  }, [_vm._v("\n                1. "), _c('button', {
    staticClass: "hover:underline",
    on: {
      "click": _vm.goToPromptTab
    }
  }, [_vm._v("Create Prompt")])])])]), _vm._v(" "), _c('li', {
    staticClass: "flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-check text-lg text-green-600"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('div', {
    staticClass: "text-sm font-semibold text-slate-800"
  }, [_vm._v("\n                2. "), _c('button', {
    staticClass: "hover:underline",
    on: {
      "click": _vm.goToSettingsTab
    }
  }, [_vm._v("Choose Settings")])])])]), _vm._v(" "), _c('li', {
    staticClass: "flex items-center"
  }, [(_vm.students_invited) ? _c('i', {
    staticClass: "fa-solid fa-circle-check text-lg text-green-600 mt-0.5"
  }) : _c('i', {
    staticClass: "far fa-circle text-lg text-slate-400"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('div', {
    staticClass: "text-sm font-semibold text-slate-800"
  }, [_vm._v("\n                3. "), _c('button', {
    staticClass: "hover:underline",
    on: {
      "click": _vm.inviteStudents
    }
  }, [_vm._v("Invite Students")])])])]), _vm._v(" "), (_vm.roundtable.type === 'verbal') ? _c('li', {
    staticClass: "flex items-center"
  }, [_c('i', {
    staticClass: "far fa-circle text-lg text-slate-400"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('div', {
    staticClass: "text-sm font-semibold text-slate-800"
  }, [_vm._v("\n                4. "), _c('button', {
    staticClass: "hover:underline",
    on: {
      "click": _vm.startDiscussion
    }
  }, [_vm._v("Start Discussion")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 text-sm text-gray-800 font-manrope cursor-pointer hover:underline",
    on: {
      "click": _vm.howItWorks
    }
  }, [_vm._v("\n          How does this work?\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "h-px bg-slate-100"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7b62e6e9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/checklist.vue
// module id = 1073
// module chunks = 61